module.exports = __webpack_public_path__ + "static/media/covi_per_soa_and.387701ff.png";